var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsEnvSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8144 7.06176C32.4828 3.73017 28.0514 1.89941 23.3419 1.89941C18.626 1.89941 14.2011 3.73017 10.8695 7.06176C7.53791 10.3934 5.70068 14.8247 5.70068 19.5342C5.70068 29.0632 14.7121 36.9943 19.5575 41.251C20.2303 41.8461 20.806 42.3572 21.2718 42.7842C21.854 43.3276 22.598 43.5993 23.3419 43.5993C24.0859 43.5993 24.8298 43.3276 25.4056 42.7842C25.8714 42.3572 26.4536 41.8461 27.1264 41.251C31.9653 36.9943 40.9767 29.0632 40.9767 19.5342C40.9767 14.8247 39.146 10.3934 35.8144 7.06176Z",
    fill: "#38BCDB",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2155 14.8277C31.7187 14.8277 34.5558 14.5069 34.5558 14.1123L33.0263 12.7061C32.9523 12.854 32.6563 12.9774 31.546 13.1008C30.6578 13.1994 29.4737 13.2488 28.2154 13.2488C26.9573 13.2488 25.773 13.1994 24.8848 13.1008C23.7747 12.9774 23.4785 12.8294 23.4045 12.7061L21.875 14.1123C21.875 14.5071 24.7122 14.8277 28.2153 14.8277H28.2155Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9025 12.608C32.9025 12.8942 30.8039 13.126 28.2152 13.126C25.6263 13.126 23.5278 12.8942 23.5278 12.608C23.5278 12.3218 25.6264 12.0898 28.2152 12.0898C30.8039 12.0898 32.9025 12.3218 32.9025 12.608Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7299 14.7543C31.5211 14.9023 29.9174 14.9763 28.2153 14.9763C26.513 14.9763 24.9095 14.9023 23.7253 14.7789C23.6019 14.7543 23.4785 14.7543 23.3553 14.7295L21.875 16.0864C21.875 16.4812 24.712 16.8018 28.2153 16.8018C31.7184 16.8018 34.5555 16.481 34.5555 16.0864L33.0752 14.7295C32.9764 14.7297 32.8531 14.7543 32.7298 14.7543H32.7299Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1663 21.5387C27.6975 21.5387 27.2781 21.5141 26.9327 21.4893C26.7108 21.4647 26.5628 21.4399 26.4888 21.4153V28.619C26.5874 28.693 27.2041 28.767 28.1663 28.767C29.1284 28.767 29.7205 28.6684 29.8438 28.619V21.3906C29.7451 21.4152 29.6218 21.44 29.3998 21.4646C29.0544 21.514 28.6102 21.5386 28.1663 21.5386V21.5387Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1661 18.9481C27.2534 18.9481 26.3899 18.8988 25.7237 18.8248C25.2797 18.7755 25.033 18.7261 24.8604 18.6768L26.4638 21.2424C26.5378 21.3164 27.1546 21.3904 28.1413 21.3904C29.128 21.3904 29.7448 21.2918 29.8188 21.2424L31.4473 18.6768C31.2993 18.7261 31.0279 18.7754 30.5837 18.8248C29.9423 18.8989 29.0788 18.9481 28.1661 18.9481H28.1661Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.166 28.8908C27.6972 28.8908 27.2779 28.8662 26.9325 28.8414C26.7597 28.8168 26.6365 28.792 26.5625 28.792L27.3027 30.0995V32.3692C27.3027 32.8132 27.6234 33.2079 28.0428 33.2573C28.561 33.3313 29.0049 32.9119 29.0049 32.4186V30.0995L29.7451 28.8166C29.6465 28.8412 29.5477 28.866 29.3751 28.866C29.0542 28.8662 28.61 28.8908 28.1661 28.8908L28.166 28.8908Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7861 16.8022V18.4797C24.9341 18.6031 26.1924 18.8005 28.1659 18.8005C30.1396 18.8005 31.3977 18.6277 31.5457 18.4797V16.8022C30.5342 16.8762 29.3747 16.9256 28.1659 16.9256C26.9324 16.9256 25.7729 16.8762 24.7861 16.8022Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5905 20.6016C22.5165 20.6262 22.4671 20.6262 22.3931 20.651C22.5165 21.095 22.5905 21.6377 22.5905 22.2545L18.8654 22.9452C18.7914 22.5753 18.4706 22.2791 18.0758 22.2791C17.9772 22.2791 17.8784 22.3037 17.8044 22.3285L16.3241 19.7874C16.5215 19.4915 16.6695 19.1461 16.6941 18.7759C16.7681 17.8878 16.2501 17.049 15.436 16.7283C14.992 16.5555 14.5232 16.5309 14.1039 16.6543C14.2273 17.1725 14.3013 17.8138 14.3013 18.5292C14.3013 19.3187 14.2027 20.0341 14.0545 20.5768C14.7206 20.7742 15.3866 20.6262 15.9048 20.2561L17.3603 22.7477C17.3109 22.8711 17.2617 22.9945 17.2617 23.1177V23.3891L14.6218 24.9433C14.6465 24.5486 14.7204 24.1786 14.7946 23.8578C14.7206 23.8332 14.6712 23.8084 14.5972 23.8084C13.4871 23.5616 12.377 24.3018 12.1548 25.4367C11.9574 26.4974 12.673 27.583 13.7337 27.8051C14.1037 27.8791 14.4739 27.8545 14.7945 27.7311C14.6465 27.1884 14.5477 26.4482 14.5477 25.6341L17.2121 24.0552V32.3937C17.2121 32.8131 17.5328 33.2079 17.9522 33.2325C18.4456 33.2819 18.8404 32.8871 18.8404 32.4184L18.8405 23.5375L22.5411 22.8467C22.5165 23.4881 22.4425 24.0802 22.2943 24.5242C22.6397 24.6476 22.9851 24.6722 23.355 24.5982C24.4158 24.3762 25.1313 23.3153 24.9339 22.2298C24.8107 21.0952 23.7252 20.3551 22.5905 20.6017L22.5905 20.6016Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4646",
    x: 0.200684,
    y: 0.399414,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4646",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsEnvSensor);
export default __webpack_public_path__ + "static/media/eventsEnvSensor.a6e8d08d8494b17e59280bca6674f9b7.svg";
export { ForwardRef as ReactComponent };